import { render, staticRenderFns } from "./ctf-link.vue?vue&type=template&id=6d8575f6&scoped=true&"
import script from "./ctf-link.vue?vue&type=script&lang=js&"
export * from "./ctf-link.vue?vue&type=script&lang=js&"
import style0 from "./ctf-link.vue?vue&type=style&index=0&id=6d8575f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8575f6",
  null
  
)

export default component.exports